export default __webpack_public_path__ + "static/BAP_4279-Verbessert-NR_rgb_fine-86e9d8b87da7c93fa84d4a5b21e14bad.jpg";